<nav class="mi4-navbar mi4-top-navbar mi4-navbar-inverse navbar navbar-expand-sm navbar-dark py-0 pr-0">
  <div class="collapse navbar-collapse">
    <ul class="mi4-navbar-nav navbar-nav ml-md-auto mt-0">
      <li class="nav-item dropdown p-0">
        <a class="mi4-user-nav-dropdown nav-link dropdown-toggle d-flex align-items-center py-3" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <div class="d-flex justify-content-center align-items-center pr-2">
            <div class="user-info">
              <p id="user-name">{{userProfile.name | lowercase}}</p>
              <p id="user-company"><em>{{companyDisplayName || (userProfile.currentCompany | titlecase)}}</em></p>
            </div>
            <img id="user-logo" [src]="companylogo" />
          </div>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown" style="font-size: 0.9em;">
          <a class="dropdown-item" (click)="openUserPage()">My Profile</a>
          <a class="dropdown-item" routerLink="/company-select">Change Companies</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-muted "><i>Portal Version: {{portalVersion}}</i></a>
          <a class="dropdown-item" href="mailto:support@mi4.com?Subject=Report%20Viewer%20Issue">Support</a>
          <a class="dropdown-item" routerLink="/logout">Logout</a>
        </div>
      </li>
    </ul>
  </div>
</nav>


